import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl p-8 md:p-12">
            <div className="flex-1 text-background-50 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl mb-4">
                <i className="ri-smartphone-line mr-2"></i>
                随时随地 · 吃瓜不停
              </h2>
              <p className="text-background-50/90 text-sm leading-relaxed mb-6">
                {appInfo.description}
              </p>
              <ul className="space-y-2 mb-6">
                {appInfo.features.map((f, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-background-50/80">
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-check-line text-accent-300 text-sm"></i>
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
              <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
                <a
                  href="#app"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50 text-primary-600 rounded-full font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer no-underline"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS 下载
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-background-50/40 text-background-50 rounded-full font-medium text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer no-underline"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </a>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="relative w-48 h-80 bg-background-50/10 rounded-3xl border-4 border-background-50/20 overflow-hidden">
                <div className="p-4 h-full flex flex-col">
                  <div className="text-center mb-3">
                    <span className="text-xs text-background-50/60">吃瓜网站线路一</span>
                  </div>
                  <div className="flex-1 flex flex-col gap-2">
                    <div className="bg-background-50/20 rounded-lg h-10"></div>
                    <div className="bg-background-50/20 rounded-lg h-16"></div>
                    <div className="bg-background-50/20 rounded-lg h-14"></div>
                    <div className="bg-background-50/20 rounded-lg h-14"></div>
                    <div className="bg-background-50/20 rounded-lg h-10 mt-auto"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}